export default __webpack_public_path__ + "static/media/image-cadeau.ff57aa3a.png";